import React, { Component, Fragment } from "react"
import Field from "../../Common/Field/Field"
import ModuleHeader from "../ModuleHeader"
import FileUpload from "../../FileUpload/FileUpload"
import Button from "../../Buttons/Button"

export default class MarkerModule extends Component {
  state = {
    _id: "",
    marker: [],
    STATUS: [],
    assignedToList: [],
    disabled: false
  }

  componentWillMount() {
    const {
      _id,
      marker,
      markerProcess,
      STATUS,
      assignedToList,
      disabled
    } = this.props

    this.setState({
      _id,
      marker,
      markerProcess,
      STATUS,
      assignedToList,
      disabled
    })
  }

  componentWillReceiveProps(nextProps) {
    const {
      _id,
      marker,
      markerProcess,
      STATUS,
      assignedToList,
      disabled
    } = nextProps

    this.setState({
      _id,
      marker,
      markerProcess,
      STATUS,
      assignedToList,
      disabled
    })
  }

  render() {
    const { marker, STATUS } = this.state
    const { permissions } = this.props
    return (
      <div class="card-filter" id="marker" style={{ marginBottom: ".5%" }}>
        <div class="col-md-12">
          <ModuleHeader
            header={"Marker "}
            onClick={this.onOpenModal}
            _id={this.state._id}
            updateModulesMain={this.props.updateModulesMain}
            moduleName={"marker"}
            disabled={this.state.disabled}
            process={this.state.markerProcess}
            statusList={STATUS}
          />
          <div class="col-md-12 " style={{ paddingBottom: "1%" }}>
            <form name="markerForm">
              <div class="wash-container">
                <div class="col-md-12 no-padding">
                  <div class="col-md-12 no-padding">
                    {/* <div class="col-md-2 step-one">
                        <div class="form-group">
                          <label for="ref-no">Assigned To</label>
                          <br />
                          <div class="custom-async-select">
                            <Async
                                name="assignedTo"
                                value={value.assignedTo}
                                // onInputChange={this.getFabricNumber}
                                // onChange={(value) => this.props.getFabricInfo(value,index)}
                                placeholder="Find AssignedTo"
                                options={this.state.assignedToList}
                                disabled = {true}
                            />
                        </div>
                        </div>
                      </div> */}
                    {/* <div class="col-md-2 step-one">
                          <Field
                            isFormGroup={true}
                            inputType="select"
                            inputName="status"
                            value={value.status}
                            options={STATUS}
                            index ={index}
                            label ={"Status"}
                            onChange={this.props.updateMarker}
                            disabled={this.state.disabled}
                          />
                      </div> */}
                    {/* <div class="col-md-2 step-one">
                      <Field
                          isFormGroup={true}
                          inputType="date"
                          inputName="completedDate"
                          label="Date Completed"
                          value={value.completedDate}
                          index ={index}
                          onChange={this.props.updateMarker}
                          disabled={this.state.disabled}
                        />
                      </div> */}
                  </div>
                </div>
                <div class="col-md-12 hide-customer-site">
                  <FileUpload
                    Heading="Upload Images"
                    moduleName={"marker"}
                    getRefImages={refImages =>
                      this.props.getRefImages(refImages, "marker")
                    }
                    disabled={this.state.disabled}
                    uploadedDocs={marker.refImages ? marker.refImages : null}
                    imageTypeOption={[]}
                  />
                </div>
                <div class="col-md-12 step-one">
                  <Field
                    isFormGroup={true}
                    inputType="textarea"
                    inputName="comments"
                    value={marker.comments}
                    label="comments"
                    onChange={this.props.updateMarker}
                    disabled={this.state.disabled}
                  />
                </div>
              </div>
              {!this.state.disabled &&
                (permissions.create || permissions.edit) && (
                  <div class="col-md-12 no-padding text-center profile-btn">
                    <Button
                      buttonName={"save"}
                      onClick={e => this.props.createMarker(e)}
                    />
                    <Button
                      buttonName={"Complete"}
                      onClick={e => this.props.completeMarker(e)}
                    />
                  </div>
                )}
            </form>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SampleRequest/MarkerModule/index.js